import get from 'lodash/get'

// Action Types
const DATA_SUCCESS = 'steppingblocks/demo/SUCCESS'

// Reducer
const initialState = {
  audited: true,
  dimName: null,
  logo: null,
  schoolCatalog: null,
  shortName: null,
}

export default (reduxState = initialState, action) => {
  const { type, audited, dimName, logo, schoolCatalog, shortName } = action
  switch (type) {
    case DATA_SUCCESS:
      return {
        ...reduxState,
        audited,
        dimName,
        logo,
        schoolCatalog,
        shortName,
      }
    default:
      return reduxState
  }
}

// Action Performers
export const performSetDemoClientData = params => async dispatch => {
  dispatch({
    type: DATA_SUCCESS,
    audited: get(params, 'audited', true),
    dimName: get(params, 'dimName'),
    logo: get(params, 'logo'),
    schoolCatalog: get(params, 'schoolCatalog', true),
    shortName: get(params, 'shortName'),
  })
}



// WEBPACK FOOTER //
// ./src/routes/authenticated/Demo/demoDuck.js